// src/components/CustomUserbackProvider.jsx
import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
import { UserbackProvider } from "@userback/react";
import { siteurl, userBackToken } from "../constant/actionType";
const CustomUserbackProvider = ({ children }) => {
    const loginUserData = JSON.parse(localStorage.getItem("LoginUserData"));
    const isLoginPage =
        // const isLoginPage = 
        // window.location.href === "http://localhost:3000/Login" ||
        // window.location.href === "http://localhost:3000/login" ||
        // window.location.href === "http://localhost:3000";

        window.location.href === `${siteurl}/login` ||
        window.location.href === `${siteurl}/Login` ||
        window.location.href === `${siteurl}`;
    const options = isLoginPage
        ? { autohide: false, } // empty config on login
        : {
            autohide: false,
            user_data: {
                id: loginUserData?.userName?.individual_id || "",
                info: {
                    name: `${loginUserData?.userName?.first_name ?? ""} ${loginUserData?.userName?.last_name ?? ""}`,
                    email: loginUserData?.userName?.email || "",
                },
            },
        };

    return (
        <UserbackProvider token={userBackToken?userBackToken:""} options={options}>
            {children}
        </UserbackProvider>
    );
};

export default CustomUserbackProvider;
